import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import styles from "./ElementTooltipExpression.module.scss";

const _regex = /\r?\n|\r|\n/g;

function ElementTooltipExpression({ node }) {
  const _expression = nodeUtils.getExpression(node);

  return (
    <>
      {_expression && (
        <div className={styles["tooltip__expression"]}>
          {_expression.split(_regex).map((e, index) => (
            <div key={index} className={styles["tooltip__expression-line"]}>
              {e}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default ElementTooltipExpression;
